export function preventBubbling(event) {
  if (event) {
    event.stopPropagation();
  }
}
export function preventDefault(event) {
  if (event) {
    event.preventDefault();
  }
}
export function preventAll(event) {
  preventBubbling(event);
  preventDefault(event);
}